import { actionTypes } from '../constants/consumption';

const INITIAL_STATE = {
    currentBalanceChain: 0.00,
    currentValueCredit: 0.00,
}

const reducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.GET_CURRENT_BALANCE_CHAIN:
            return {...state.currentBalanceChain};
        case actionTypes.SET_CURRENT_BALANCE_CHAIN:
            return { ...state, currentBalanceChain: action.payload.currentBalanceChain }
        case actionTypes.GET_CURRENT_VALUE_CREDIT:
            return {...state.currentValueCredit};
        case actionTypes.SET_CURRENT_VALUE_CREDIT:
            return { ...state, currentValueCredit: action.payload.currentValueCredit }
        default:
            return state;
    }
}

export default reducers;